import type { AuthLocale } from "./types";

const ptBR = {
  brand: "Elefante",
  localeLabel: "Idioma",
  portuguese: "Português",
  english: "English",
  signInTo: "Entrar em {app}",
  createFor: "Criar conta para {app}",
  email: "E-mail",
  password: "Senha",
  currentPassword: "Senha atual",
  newPassword: "Nova senha",
  confirmPassword: "Confirmar senha",
  name: "Nome",
  remember: "Lembrar de mim neste dispositivo",
  signIn: "Entrar",
  signUp: "Criar conta",
  google: "Continuar com Google",
  signUpGoogle: "Criar conta com Google",
  socialSignInFailed: "Não foi possível entrar com Google. Tente novamente.",
  authorizationExpired: "A entrada no aplicativo expirou. Volte ao convite e tente novamente.",
  passkey: "Entrar com passkey",
  magicLink: "Receber link por e-mail",
  forgotPassword: "Esqueci minha senha",
  noAccount: "Ainda não tem conta?",
  haveAccount: "Já tem conta?",
  genericError: "Não foi possível concluir agora. Tente novamente.",
  genericEmailSent: "Se o endereço puder receber esta mensagem, enviaremos as instruções em instantes.",
  passwordHint: "Use entre 8 e 128 caracteres. Espaços são permitidos.",
  passwordsDiffer: "As senhas não coincidem.",
  passwordLengthError: "A nova senha deve ter entre 8 e 128 caracteres.",
  currentPasswordIncorrect: "A senha atual está incorreta.",
  passwordCompromised: "Esta senha aparece em vazamentos conhecidos. Escolha outra senha.",
  showPassword: "Mostrar senha",
  hidePassword: "Ocultar senha",
  magicTitle: "Entrar por e-mail",
  magicIntro: "Enviaremos um link de uso único. Por segurança, abrir o link não conclui o login automaticamente.",
  sendLink: "Enviar link",
  forgotTitle: "Recuperar senha",
  forgotIntro: "Informe seu e-mail para receber instruções de recuperação.",
  resetTitle: "Definir nova senha",
  resetAction: "Salvar nova senha",
  invalidLink: "Este link está incompleto ou não é mais válido.",
  verifyTitle: "Confirmar e-mail",
  verifyIntro: "Confirme abaixo para verificar este endereço de e-mail.",
  verifyAction: "Confirmar meu e-mail",
  magicConfirmTitle: "Confirmar entrada",
  magicConfirmIntro: "Confirme abaixo para usar este link e entrar. O link só será consumido agora.",
  magicConfirmAction: "Entrar com este link",
  consentTitle: "Autorizar {app}",
  consentIntro: "Este aplicativo solicita acesso às informações abaixo:",
  allow: "Permitir",
  deny: "Cancelar",
  scopeOpenid: "Confirmar sua identidade",
  scopeProfile: "Ver seu nome e perfil básico",
  scopeEmail: "Ver seu endereço de e-mail",
  scopeOffline: "Manter sua sessão ativa",
  account: "Sua conta",
  actionCompleted: "Alteração concluída.",
  profile: "Perfil",
  save: "Salvar",
  emailChange: "Alterar e-mail",
  emailChangeHint: "O novo endereço só será usado depois da confirmação.",
  security: "Segurança",
  reauthenticationTitle: "Confirmar identidade",
  reauthenticationIntro: "Para alterar formas de entrada, e-mail ou excluir a conta, confirme sua identidade. A confirmação vale por cinco minutos.",
  reauthenticationRequired: "Confirme sua identidade abaixo para liberar alterações de segurança.",
  reauthenticationConfirmed: "Identidade confirmada. As alterações de segurança estão liberadas por cinco minutos.",
  confirmWithPassword: "Confirmar com senha",
  confirmWithGoogle: "Confirmar com Google",
  confirmWithPasskey: "Confirmar com passkey",
  confirmWithMagicLink: "Enviar link de confirmação",
  confirmationPassword: "Sua senha",
  passwordSet: "Definir ou trocar senha",
  identities: "Formas de entrada",
  linked: "Vinculado em {date}",
  linkGoogle: "Vincular Google",
  identityLinkFailed: "Não foi possível vincular esta conta Google.",
  identityEmailMismatch: "Use uma conta Google com o mesmo e-mail desta conta Elefante.",
  unlink: "Desvincular",
  passkeys: "Passkeys",
  passkeyHint: "Use biometria, PIN ou uma chave física. Passkeys não são MFA neste serviço.",
  passkeyName: "Nome da passkey",
  addPasskey: "Adicionar passkey",
  rename: "Renomear",
  remove: "Remover",
  createdOn: "Criada em {date}",
  lastUsed: "Usada em {date}",
  sessions: "Sessões e dispositivos",
  sessionsHint: "Cada entrada cria uma sessão. O mesmo dispositivo pode aparecer mais de uma vez.",
  currentSession: "Esta sessão",
  sessionCreated: "Sessão criada em {date}",
  revoke: "Revogar",
  revokeOthers: "Sair dos outros dispositivos",
  logout: "Sair deste app",
  logoutEverywhere: "Sair de todos os dispositivos",
  dangerZone: "Exclusão da conta",
  deletionIntro: "A exclusão entra em vigor após 30 dias. Até lá, você pode cancelar a solicitação.",
  requestDeletion: "Solicitar exclusão",
  cancelDeletion: "Cancelar exclusão",
  deletionPending: "Exclusão solicitada. Sua conta está restrita até {date}.",
  confirmDestructive: "Esta ação afeta o acesso à sua conta. Confirme para continuar.",
  loading: "Carregando…",
  privacy: "Privacidade",
  terms: "Termos",
  privacyTitle: "Aviso de Privacidade",
  termsTitle: "Termos de Uso",
  legalDraft: "Versão operacional inicial — última atualização: julho de 2026.",
  privacyBody1: "O Elefante Auth trata dados de conta e segurança para autenticar você nos aplicativos Elefante que escolher usar.",
  privacyBody2: "Podemos tratar nome, e-mail, identidades vinculadas, passkeys, sessões, registros técnicos de segurança e solicitações de exclusão. Cada aplicativo continua responsável pelos próprios dados e permissões.",
  privacyBody3: "Não compartilhamos credenciais entre subdomínios. Cada aplicativo recebe apenas os dados autorizados e mantém sua própria sessão. Você pode revisar sessões e solicitar a exclusão da conta na área da conta.",
  termsBody1: "Use o serviço somente para acessar aplicativos Elefante de forma legítima e não tente contornar controles de segurança ou acessar contas de terceiros.",
  termsBody2: "Podemos limitar tentativas, revogar sessões ou suspender acesso para proteger usuários e a infraestrutura. A disponibilidade de cada aplicativo e suas regras específicas são responsabilidade do respectivo aplicativo.",
  termsBody3: "Estes textos são um rascunho operacional e poderão ser atualizados antes ou depois do lançamento.",
  backToSignIn: "Voltar para entrar",
  ariaRequired: "obrigatório",
  unknownDevice: "Dispositivo desconhecido"
} as const;

const en: Record<keyof typeof ptBR, string> = {
  brand: "Elefante",
  localeLabel: "Language",
  portuguese: "Português",
  english: "English",
  signInTo: "Sign in to {app}",
  createFor: "Create an account for {app}",
  email: "Email",
  password: "Password",
  currentPassword: "Current password",
  newPassword: "New password",
  confirmPassword: "Confirm password",
  name: "Name",
  remember: "Remember me on this device",
  signIn: "Sign in",
  signUp: "Create account",
  google: "Continue with Google",
  signUpGoogle: "Create account with Google",
  socialSignInFailed: "We couldn't sign in with Google. Please try again.",
  authorizationExpired: "The application sign-in expired. Return to the invitation and try again.",
  passkey: "Sign in with a passkey",
  magicLink: "Get an email sign-in link",
  forgotPassword: "Forgot password",
  noAccount: "Don't have an account?",
  haveAccount: "Already have an account?",
  genericError: "We couldn't complete that right now. Please try again.",
  genericEmailSent: "If this address can receive the message, we will send instructions shortly.",
  passwordHint: "Use 8 to 128 characters. Spaces are allowed.",
  passwordsDiffer: "The passwords do not match.",
  passwordLengthError: "The new password must be between 8 and 128 characters.",
  currentPasswordIncorrect: "The current password is incorrect.",
  passwordCompromised: "This password appears in known data breaches. Choose another password.",
  showPassword: "Show password",
  hidePassword: "Hide password",
  magicTitle: "Sign in by email",
  magicIntro: "We will send a single-use link. For your safety, opening it does not sign you in automatically.",
  sendLink: "Send link",
  forgotTitle: "Reset password",
  forgotIntro: "Enter your email to receive reset instructions.",
  resetTitle: "Choose a new password",
  resetAction: "Save new password",
  invalidLink: "This link is incomplete or no longer valid.",
  verifyTitle: "Confirm email",
  verifyIntro: "Confirm below to verify this email address.",
  verifyAction: "Confirm my email",
  magicConfirmTitle: "Confirm sign-in",
  magicConfirmIntro: "Confirm below to use this link and sign in. The link will only be consumed now.",
  magicConfirmAction: "Sign in with this link",
  consentTitle: "Authorize {app}",
  consentIntro: "This application is requesting access to:",
  allow: "Allow",
  deny: "Cancel",
  scopeOpenid: "Confirm your identity",
  scopeProfile: "View your name and basic profile",
  scopeEmail: "View your email address",
  scopeOffline: "Keep your session active",
  account: "Your account",
  actionCompleted: "Change completed.",
  profile: "Profile",
  save: "Save",
  emailChange: "Change email",
  emailChangeHint: "The new address will only be used after confirmation.",
  security: "Security",
  reauthenticationTitle: "Confirm identity",
  reauthenticationIntro: "Before changing sign-in methods, email, or deleting the account, confirm your identity. Confirmation is valid for five minutes.",
  reauthenticationRequired: "Confirm your identity below to unlock security changes.",
  reauthenticationConfirmed: "Identity confirmed. Security changes are unlocked for five minutes.",
  confirmWithPassword: "Confirm with password",
  confirmWithGoogle: "Confirm with Google",
  confirmWithPasskey: "Confirm with passkey",
  confirmWithMagicLink: "Send confirmation link",
  confirmationPassword: "Your password",
  passwordSet: "Set or change password",
  identities: "Sign-in methods",
  linked: "Linked on {date}",
  linkGoogle: "Link Google",
  identityLinkFailed: "We couldn't link this Google account.",
  identityEmailMismatch: "Use a Google account with the same email as this Elefante account.",
  unlink: "Unlink",
  passkeys: "Passkeys",
  passkeyHint: "Use biometrics, a PIN, or a security key. Passkeys are not MFA in this service.",
  passkeyName: "Passkey name",
  addPasskey: "Add passkey",
  rename: "Rename",
  remove: "Remove",
  createdOn: "Created {date}",
  lastUsed: "Used {date}",
  sessions: "Sessions and devices",
  sessionsHint: "Each sign-in creates a session. The same device may appear more than once.",
  currentSession: "This session",
  sessionCreated: "Session created {date}",
  revoke: "Revoke",
  revokeOthers: "Sign out other devices",
  logout: "Sign out of this app",
  logoutEverywhere: "Sign out all devices",
  dangerZone: "Delete account",
  deletionIntro: "Deletion takes effect after 30 days. You may cancel the request until then.",
  requestDeletion: "Request deletion",
  cancelDeletion: "Cancel deletion",
  deletionPending: "Deletion requested. Your account is restricted until {date}.",
  confirmDestructive: "This action affects access to your account. Confirm to continue.",
  loading: "Loading…",
  privacy: "Privacy",
  terms: "Terms",
  privacyTitle: "Privacy Notice",
  termsTitle: "Terms of Use",
  legalDraft: "Initial operating version — last updated July 2026.",
  privacyBody1: "Elefante Auth processes account and security data to authenticate you to the Elefante applications you choose to use.",
  privacyBody2: "We may process your name, email, linked identities, passkeys, sessions, technical security logs, and deletion requests. Each application remains responsible for its own data and permissions.",
  privacyBody3: "We do not share credentials across subdomains. Each application receives only authorized data and keeps its own session. You can review sessions and request account deletion from the account area.",
  termsBody1: "Use the service only to access Elefante applications legitimately. Do not bypass security controls or access other people's accounts.",
  termsBody2: "We may limit attempts, revoke sessions, or suspend access to protect users and infrastructure. Each application is responsible for its availability and application-specific rules.",
  termsBody3: "These texts are an operational draft and may be updated before or after launch.",
  backToSignIn: "Back to sign in",
  ariaRequired: "required",
  unknownDevice: "Unknown device"
};

export type MessageKey = keyof typeof ptBR;

export function detectLocale(languages?: readonly string[]): AuthLocale {
  const candidates = languages ?? (typeof navigator === "undefined" ? [] : navigator.languages);
  for (const language of candidates) {
    const normalized = language.toLowerCase();
    if (normalized.startsWith("pt")) return "pt-BR";
    if (normalized.startsWith("en")) return "en";
  }
  return "pt-BR";
}

export function translate(locale: AuthLocale, key: MessageKey, values?: Readonly<Record<string, string>>): string {
  let result: string = (locale === "en" ? en : ptBR)[key];
  if (!values) return result;
  for (const [name, value] of Object.entries(values)) {
    result = result.replaceAll(`{${name}}`, value);
  }
  return result;
}

export function formatDate(locale: AuthLocale, value: string): string {
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return value;
  return new Intl.DateTimeFormat(locale, { dateStyle: "medium", timeStyle: "short" }).format(date);
}
